//src/componets/Route/ProtectedRoute.js
import React from 'react';
// import { Navigate } from 'react-router-dom';
import { Navigate, Outlet } from 'react-router-dom';
// const ProtectedRoute = ({ children }) => {
//   const token = localStorage.getItem('token');
//   if (!token) {
//     return <Navigate to="/login" />;
//   }
//   return children;
// };



// const ProtectedRoute = ({ children, allowedRoles }) => {
//   const token = localStorage.getItem("token");
//   const userRole = localStorage.getItem("role"); // Assuming user role is stored in localStorage

//   // If there's no token or userRole doesn't match allowed roles
//   if (!token || !allowedRoles.includes(userRole)) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };



const ProtectedRoute = ({ allowedRoles }) => {
  const token = localStorage.getItem("token");
  const userRole = localStorage.getItem("role"); // Get role from local storage

  // Check if user is authenticated
  if (!token) {
    return <Navigate to="/login" replace />;
  }

  // Check if user has the correct role
  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/unauthorized" replace />;
  }

  return <Outlet />;
};

// const ProtectedRoute = ({ roles, redirectPath = '/login' }) => {
//   const isAuthenticated = localStorage.getItem('token');
//   const userRole = localStorage.getItem('role'); // Assuming the role is stored in localStorage

//   if (!isAuthenticated) {
//     return <Navigate to={redirectPath} replace />;
//   }

//   // Check if the user's role is allowed to access the route
//   if (roles && !roles.includes(userRole)) {
//     return <Navigate to="/unauthorized" replace />; // Redirect to an unauthorized page
//   }

//   return <Outlet />;
// };




// const ProtectedRoute = ({ children, allowedRoles = [] }) => {
//   const token = localStorage.getItem("token");
//   const userRole = localStorage.getItem("role"); // Assuming user role is stored in localStorage

//     // Ensure allowedRoles is an array
//     if (!Array.isArray(allowedRoles)) {
//       console.error("allowedRoles must be an array");
//       return <Navigate to="/login" />;
//     }

//   // If there's no token or userRole doesn't match allowed roles
//   if (!token || !allowedRoles.includes(userRole)) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };

export default ProtectedRoute;